export enum EServiceRent {
    Base = 1,
    Nomenclature = 2,
    PremiumOFD = 3,
}
